import { Alert, Box } from "@mui/material";

export type TransitionOutcome = "approved" | "rejected";

type Props = {
  outcome: TransitionOutcome;
  approvedMessage: string;
  rejectedMessage: string;
};

export function TransitionSuccessCard({
  outcome,
  approvedMessage,
  rejectedMessage,
}: Props) {
  const severity = outcome === "approved" ? "success" : "info";
  const message = outcome === "approved" ? approvedMessage : rejectedMessage;
  return (
    <Box sx={{ p: 3 }}>
      <Alert severity={severity}>{message}</Alert>
    </Box>
  );
}
